import { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { v4 as uuid } from 'uuid';

import { setCreateSubstepOpen } from '../../app/recipeCreation/createRecipe.slice';
import { changeRecipeOnServing, setIsViewRecipeOpen } from '../../app/recipePage/recipePage.slice';
import { useAppDispatch, useAppSelector } from '../../app/store/hooks';
import CreateSubstep from '../recipeCreation/recipeSteps/createSubstep';
import StepsView from '../recipeCreation/stepView';
import { CREATED_SOURCE, LocationEnum, SubStepTypeEnum } from '../recipeCreation/utils/constants';
import { TextMidMedium } from '../typography';
import ViewRecipeHeader from './ViewRecipeHeader';
import styles from "./viewRecipeSteps.module.css";

const initialSteps = () => {
    const steps = [{
        id: uuid(),
        ingredientsTitle: '',
        name: '',
        subSteps: [{
            id: uuid(),
            subStepUId: uuid(),
            name: '',
            type: SubStepTypeEnum.OUTSIDE_INSTRUCTION,
            media: { url: "", loop: true, muted: true, title: "", duration: 0, startTime: 0 },
            parameters: {
                location: LocationEnum.NONE,
                outsideDescription: '',
            },
            created_at: null,
            updated_at: null,
            Recipe_Presets: [],
            SubSteps_Ingredients_E3s: [],
        }]
    }];
    return steps;
};

const ViewRecipeSteps = () => {
    const recipe = useAppSelector((state) => state.recipePage.recipe);
    const servingSizeSelector = useAppSelector((state) => state.recipePage.servingSize);
    const recipePerServing = recipe ? changeRecipeOnServing(recipe, servingSizeSelector) : null;
    const substeps = useMemo(() => recipePerServing?.steps[0]?.subSteps, [recipePerServing]);
    const userCreated = recipePerServing?.metadata.createdSource === CREATED_SOURCE.USER_CREATED
    const [isStepAdded, setIsStepAdded] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const history = useHistory();

    const lastStepIndex = recipePerServing?.steps.length - 1;
    const createSubstepOpen = useAppSelector((state) => state.recipeCreation.createSubstepOpen);

    const onClickBack = () => {
        window.scrollTo(0, 0);
        dispatch(setIsViewRecipeOpen(false));
        history.goBack();
    }

    const onAddStep = () => {
        setIsStepAdded(true);
        dispatch(setCreateSubstepOpen(true));
    }

    const initialRecipe = { ...recipePerServing, steps: initialSteps() }

    if (createSubstepOpen && isStepAdded) return <CreateSubstep setIsStepAdded={setIsStepAdded} stepAdded={isStepAdded} stepId={initialRecipe.steps[0].id}
        substepId={initialRecipe.steps[0].subSteps[0].id} subStepUId={initialRecipe.steps[0].subSteps[0].subStepUId} substeps={initialRecipe.steps[0].subSteps} />

    return (
        <Box className={styles.view_recipe_container} >
            <Box>
                <ViewRecipeHeader onClickBack={onClickBack} text={recipe?.metadata?.name ?? ''} />
            </Box>
            <Box sx={{ marginTop: recipePerServing?.steps.length === 0 ? '' : '25px' }}>
                {userCreated && recipePerServing?.steps.length === 0 && (
                    <Grid alignItems='center' container direction='row'
                        justifyContent='center' >
                        <Button className={styles.create_button_dialog} onClick={onAddStep}>
                            <Typography variant='captionparalell'>+ Add Step</Typography>
                        </Button >
                    </Grid>
                )}
                {recipePerServing?.steps.map((step: any, index: number) =>
                    <Box className={styles.recipe_per_serving_container} key={step.id}>
                        <Box className={styles.recipe_step_container}>
                            <Box className={styles.step_index}>{index + 1}</Box>
                            <Box className={styles.step_name}><TextMidMedium color="#3A3A3A" text={step.name} /></Box>
                        </Box>
                        {substeps && <StepsView createdBy={recipePerServing.metadata.created_by} createdSource={recipePerServing.metadata.createdSource} islastStep={index === lastStepIndex}
                            recipeId={recipe?.id} setIsStepAdded={setIsStepAdded} stepAdded={isStepAdded}
                            stepId={step.id} stepIndex={index} substeps={step.subSteps} />}
                    </Box>
                )
                }
            </Box>
        </Box>
    )
}

export default ViewRecipeSteps;